"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = validate;
require("core-js/modules/es.parse-float.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.match.js");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function validate(params) {
  var monthlyRent = params.monthlyRent,
    moveDate = params.moveDate;
  var errors = {};
  if (!validateMonthlyRent(monthlyRent)) {
    errors.monthlyRent = 'Please enter a number between 1 - 99,999';
  }
  if (!validateMoveDate(moveDate)) {
    errors.moveDate = 'Please select a valid date MM/DD/YYYY';
  }
  if ((0, _isEmpty["default"])(errors)) {
    return {
      isValid: true
    };
  }
  return {
    isValid: false,
    errors: errors
  };
}
function validateMonthlyRent(rentString) {
  var floatRegExp = /^([0-9]*[.])?[0-9]+$/;
  if (rentString) {
    if (rentString.match(floatRegExp)) {
      var rentNumber = parseFloat(rentString);
      return rentNumber >= 1 && rentNumber <= 99999;
    }
  }
  return false;
}
function validateMoveDate(dateString) {
  var dateRegExp = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
  if (dateString) {
    if (dateString.match(dateRegExp)) {
      return true;
    }
  }
  return false;
}